/* eslint-disable */
import { createToken } from "vue-stripe-elements-plus";
import { initValidateByPromise } from "../utils/error";
import {
  stripePay as stripePayRes,
  paypalUrl as paypalUrlRes,
  paypalPay as paypalPayRes,
  cancel as cancelRes,
  history as historyRes,
  coupon as couponRes,
  unsubscription as unsubscriptionRes
} from "../apis/payment";
import {
  updateCard as updateCardRes,
  updatePaymentMethod as updatePaymentMethodRes
} from "../apis/users";
import { updateUserInfo, initUserInfo } from "../services/users";
import {
  BEFORE_PAY_PAGE,
  ADD_PUBLISHERS_STATES,
  CURRENT_PUBLISHER_ID,
  PAYPAL_INFO,
  CURRENT_USER_INFO_SIMPLE
} from "../store/mutation-types";
import store from "../store/index";
import moment from "moment";
import { dateFormat } from "../utils/plugin_helper";
import { downgradeToken } from "../const/payment";
import fetch from "../utils/fetch";
/**
 * 更新信用卡信息
 * @returns {Promise<{code: number, msg: *}>}
 */
export async function updatePaymentMethod(paymentMethod) {
  const { data } = await updatePaymentMethodRes({ credit_card: paymentMethod });
  await initUserInfo(data);
}

/**
 * stripe 支付
 * @param id 支付方式唯一标示
 * @param name 用户姓名
 * @param card 信用卡号
 * @param coupon 优惠码
 * @param type normal : 默认配置 ; downgrade : 降级 则多传一个immediate_downgrade_token参数 2019.6.29
 * @returns {Promise<*>}
 */
export async function stripePay(
  { id, name = "", card = "", coupon = "", type = "normal" },
  isInitialPay,
  stripe,
  elements
) {
  let token = "";

  // name 为空，则是没有添加信用卡，此时 token 为空, 下面 token.id 为 undefined
  // 处理首次订阅
  if (isInitialPay) {
    // const stripToken = await createToken()
    // console.log('stripToken', stripToken)
    // // 如果存在error则说明请求出错
    // if (stripToken.error) {
    //   return initValidateByPromise(stripToken.error.message)
    // } else {
    //   token = stripToken.token
    // }
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: process.env.RETURN_URL
      }
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      return initValidateByPromise(error.message);
    } else {
      return initValidateByPromise("An unexpected error occurred.");
    }
  }
  // 如果是从active页面进入支付页面，则带上publisherId 反之则不带
  let stripePayParams = { plan_id: id, stripe_token: token.id, name, coupon };
  if (type === "downgrade") {
    stripePayParams.immediate_downgrade_token = downgradeToken;
  }
  const { data } = await stripePayRes(stripePayParams);
  await updateUserInfo({});
  if (store.getters[BEFORE_PAY_PAGE] === "ActivePage") {
    // 如果支付成功则说明已将用户自动添加到unlimited中并自动进行了发送
    const currentPublisherId = store.getters[CURRENT_PUBLISHER_ID];
    store.commit(ADD_PUBLISHERS_STATES, {
      id: currentPublisherId,
      status: "success"
    });
  }
  return data;
}

/**
 * 获取paypal 支付地址
 * @param id 支付方式唯一标示
 * @param sale 支付失败时sale = true
 * @returns {Promise<*>}
 */
export async function paypalUrl({ id, sale = false, type }) {
  // 保存paypal支付信息
  store.commit(PAYPAL_INFO, { id });
  // 获取paypal地址
  const params = {
    plan_id: id,
    sale
  };
  if (type === "downgrade") {
    params.immediate_downgrade_token = downgradeToken;
  }
  const { data } = await paypalUrlRes(params);
  return data.approval_url;
}

/**
 * 通过paypal进行订阅
 * @param token paypal回调之后token
 * @param paymentId paypal回调之后paymentId
 * @param PayerID paypal回调之后PayerID
 * @returns {Promise<void>}
 */
export async function paypalPay({ token, paymentId, PayerID }) {
  const { data } = await paypalPayRes({
    paypal_token: token,
    payment_id: paymentId,
    payer_id: PayerID
  });
  return data;
}
/**
 * 提交意见反馈
 * @param  feedback 发送的意见
 * @param type 意见提交类型
 * Cancelled: 用户最终确认取消。
 * Closed: 用户退出了取消订阅页面，没有接受优惠，也没有选择取消订阅。
 * Accepted LTO: 接受了限时优惠。

 */
export async function sendFeedback({ feedback, type = "Closed" }) {
  return fetch.post("users/self/feedbacks/quick-question", {
    Field101: feedback,
    Field103: store.getters[CURRENT_USER_INFO_SIMPLE].email,
    Field105: type
  });
}
/**
 * 取消当前订阅
 * @returns {Promise<void>}
 */
export async function cancel({ feedback }) {
  await cancelRes({ feedback });
  await updateUserInfo({});
}
/**
 * 接受半价优惠
 * @param feedback 填写的意见
 */
export async function unsubscription({ feedback }) {
  await unsubscriptionRes({ unsubscription: true, feedback });
  await updateUserInfo({});
}
/**
 * 获取当前用户历史支付记录
 * @returns {Promise<*>}
 */
export async function history({ limit = 10, offset = 0 }) {
  const { data } = await historyRes({ limit, offset });
  const result = data.map(h => {
    const date = dateFormat({
      date: moment(h.date_created),
      format: "MMMM DD, YYYY"
    });
    return {
      title: h.message, // September 14, 2017
      date
    };
  });
  return result;
}

/**
 * 获取优惠码对应信息
 * @param coupon 验证码
 * @returns {*}
 */
export async function coupon({ coupon }) {
  // 如果没有输入则直接提示无效
  if (!coupon) {
    // eslint-disable-next-line
    return Promise.reject({ msg: "Invalid Code" });
  }
  const { data } = await couponRes({ coupon });
  if (!data.valid) {
    // eslint-disable-next-line
    return Promise.reject({ msg: "Code expired" });
  } else {
    return {
      // eslint-disable-next-line
      percentOff: data.percent_off / 100
    };
  }
}



// WEBPACK FOOTER //
// ./src/services/payment.js